/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Fachliche_Fragen19Inputs */

const en__field_enum_tuda_fachliche_fragen19 = /** @type {(inputs: _Field_Enum_Tuda_Fachliche_Fragen19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`technical questions`)
};

const de__field_enum_tuda_fachliche_fragen19 = /** @type {(inputs: _Field_Enum_Tuda_Fachliche_Fragen19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachliche Fragen klären`)
};

/**
* | output |
* | --- |
* | "technical questions" |
*
* @param {_Field_Enum_Tuda_Fachliche_Fragen19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_fachliche_fragen19 = /** @type {((inputs?: _Field_Enum_Tuda_Fachliche_Fragen19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Fachliche_Fragen19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_fachliche_fragen19(inputs)
	return de__field_enum_tuda_fachliche_fragen19(inputs)
});
export { _field_enum_tuda_fachliche_fragen19 as "_field_enum_TUDA_FACHLICHE_FRAGEN" }